<div *ngIf="isInExpireRange" class="trial-expire-message-panel border-outline">

  <div class="panel-title">
      <span class="label-error-red">{{panelTitle}}</span>
  </div>

  <div class="panel-message-row">
      <span class="panel-message label-s-grey">{{panelMessage}}</span>
      <!-- <div class="button-container">
        <button class="ft-btn ft-btn-active" (click)="redirectToWebShop()">{{"trial_expire_message.lbl_buy_now" | translate}}&nbsp;</button>
      </div> -->
      <vipps-mobilepay-button 
          type="button" 
          brand="vipps" 
          language="no" 
          variant="primary" 
          rounded="true" 
          verb="pay"
          stretched="false" 
          branded="true" 
          loading="false" 
          (click)="redirectToWebShop()">
      </vipps-mobilepay-button>
  </div>

</div>

<div class="trial-expire-message-panel border-outline" *ngIf="paymentStatus && !isPaymentCaptured">

    <div  class="label-container" *ngIf="paymentStatus && paymentStatus === VippsPaymentStatus.Authorized">
        <!-- When payment is Authorized -->
        <span class="label-error-red">
            {{'lbl_payment.lbl_processing_payment' | translate}}
        </span>
    </div>
    
    <!-- When payment Failed -->
    <!-- <div class="label-container label-container--error"
        *ngIf="paymentStatus && (paymentStatus === VippsPaymentStatus.Cancelled || paymentStatus === VippsPaymentStatus.Aborted || paymentStatus === VippsPaymentStatus.Expired || paymentStatus === VippsPaymentStatus.Terminated)">
        <div class="label-container">
            <span class="label-error-red">{{'lbl_payment.lbl_payment_failed' | translate}}</span>
        </div>
        <div>
            <vipps-mobilepay-button type="button" brand="vipps" language="no" variant="primary" rounded="true" verb="pay"
                stretched="false" branded="true" loading="false" (click)="redirectToWebShop()"></vipps-mobilepay-button>
        </div>
    </div> -->
</div>